module.exports = __webpack_public_path__ + "img/noCourseImg.fb92dc48.png";